<FormularioDocumentacao v-model:estrangeiro="dadosDocumentacao.estrangeiro" />
<template>
  <div>
    <div class="form-control">
      <label for="cf_cpf">CPF*:</label>
      <input id="cf_cpf" name="cf_cpf" v-model="dadosDocumentacao.cpf" ref="cpfInput" v-mask="'###.###.###-##'"
        @input="validateCPF(false)" @blur="validateCPF(true)" required="true">
      <span v-if="cpfError" class="error-message">{{ cpfError }}</span>
    </div>
    <div class="form-control">
      <label for="cf_pis_pasep">PIS/PASEP:</label>
      <input id="cf_pis_pasep" name="cf_pis_pasep" ref="pispasepInput" v-model="dadosDocumentacao.pisPasep" v-mask="'###.#####.##-#'"
        maxlength="14"   @input="validatePisPasep"
  @blur="validatePisPasep"/>
        <span v-if="pisError" class="error-message">{{ pisError }}</span>
       </div>

    <div class="form-control">
      <label for="cf_estrangeiro">Estrangeiro?</label>
      <select name="cf_estrangeiro" id="cf_estrangeiro" required="true" v-model="dadosDocumentacao.estrangeiro">
        <option value="" selected></option>
        <option value="sim">Sim</option>
        <option value="nao">Não</option>
      </select>
    </div>
    <div class="form-control" v-if="dadosDocumentacao.estrangeiro == 'sim'">
      <label for="cf_naturalizado">Naturalizado?:</label>
      <select name="cf_naturalizado" id="cf_naturalizado" required="true" v-model="dadosDocumentacao.naturalizado">
        <option value=""></option>
        <option value="sim">Sim</option>
        <option value="nao">Não</option>
      </select>
    </div>
    <div class="form-control" v-if="dadosDocumentacao.naturalizado == 'nao' && dadosDocumentacao.estrangeiro == 'sim'">
      <label for="cf_numero_rne">Número RNE:</label>
      <input id="cf_numero_rne" name="cf_numero_rne" v-model="dadosDocumentacao.numero_rne">
    </div>
    <div class="form-control" v-if="dadosDocumentacao.naturalizado == 'nao' && dadosDocumentacao.estrangeiro == 'sim'">
      <label for="cf_orgao_emissor_rne">Órgão emissor do RNE:</label>
      <input id="cf_orgao_emissor_rne" name="cf_orgao_emissor_rne" v-model="dadosDocumentacao.orgao_emissor_rne">
    </div>
    <div class="form-control" v-if="dadosDocumentacao.naturalizado == 'nao' && dadosDocumentacao.estrangeiro == 'sim'">
      <label for="cf_casado_brasileiro">Casado com brasileiro?:</label>
      <select name="cf_casado_brasileiro" id="cf_casado_brasileiro" required="true"
        v-model="dadosDocumentacao.casado_brasileiro">
        <option value=""></option>
        <option value="sim">Sim</option>
        <option value="nao">Não</option>
      </select>
    </div>
    <div class="form-control" v-if="dadosDocumentacao.naturalizado == 'nao' && dadosDocumentacao.estrangeiro == 'sim'">
      <label for="cf_filho_brasileiro">Filho brasileiro?:</label>
      <select name="cf_filho_brasileiro" id="cf_filho_brasileiro" required="true"
        v-model="dadosDocumentacao.filho_brasileiro">
        <option value=""></option>
        <option value="sim">Sim</option>
        <option value="nao">Não</option>
      </select>
    </div>
    <div class="form-control" v-if="dadosDocumentacao.naturalizado == 'nao' && dadosDocumentacao.estrangeiro == 'sim'">
      <label for="cf_classificacao_estrangeiro">Classificação estrangeiro:</label>
      <select name="cf_classificacao_estrangeiro" id="cf_classificacao_estrangeiro" required="true"
        v-model="dadosDocumentacao.classificacao_estrangeiro">
        <option value=""></option>
        <option value="1 - Refugiado">1 - Refugiado</option>
        <option value="2 - Solicitante de refúgio">2 - Solicitante de refúgio</option>
        <option value="3 - Permanência no Brasil em razão de reunião familiar">3 - Permanência no Brasil em razão de
          reunião familiar</option>
        <option value="4 - Beneficiado pelo acordo entre países do Mercosul">4 - Beneficiado pelo acordo entre países do
          Mercosul</option>
        <option
          value="5 - Dependente de agente diplomático e/ou consular de países que mantém acordo de reciprocidade para o exercício de atividade remunerada no Brasil">
          5 - Dependente de agente diplomático e/ou consular de países que mantém acordo de reciprocidade para o
          exercício de atividade remunerada no Brasil</option>
        <option
          value="6 - Beneficiado pelo Tratado de Amizade, Cooperação e Consulta entre a República Federativa do Brasil e a República Portuguesa">
          6 - Beneficiado pelo Tratado de Amizade, Cooperação e Consulta entre a República Federativa do Brasil e a
          República Portuguesa</option>
        <option value="7 - Outra Condição">7 - Outra Condição</option>
      </select>
    </div>

    <div class="form-control" v-if="dadosDocumentacao.naturalizado == 'nao' && dadosDocumentacao.estrangeiro == 'sim'">
      <label for="cf_tempo_residencia">Tempo de residência:</label>
      <select name="cf_tempo_residencia" id="cf_tempo_residencia" required="true"
        v-model="dadosDocumentacao.tempo_residencia">
        <option value=""></option>
        <option value="Prazo determinado">Prazo determinado</option>
        <option value="Prazo indeterminado">Prazo indeterminado</option>
      </select>
    </div>
    <div class="form-control" v-if="dadosDocumentacao.naturalizado == 'nao' && dadosDocumentacao.estrangeiro == 'sim'">
      <label for="cf_data_expedicao_rne">Data expedição RNE:</label>
      <input id="cf_data_expedicao_rne" name="cf_data_expedicao_rne" type="date" required="true"
        v-model="dadosDocumentacao.data_expedicao_rne">
    </div>
    <div class="form-control" v-if="dadosDocumentacao.naturalizado == 'nao' && dadosDocumentacao.estrangeiro == 'sim'">
      <label for="cf_data_validade_rne">Data validade RNE:</label>
      <input id="cf_data_validade_rne" name="cf_data_validade_rne" type="date" required="true"
        v-model="dadosDocumentacao.data_validade_rne">
    </div>
  </div>
</template>
<script>
import { mask } from 'vue-the-mask';


export default {
  directives: { mask },
  props: {
    dadosDocumentacao: {
      type: Object,
      required: true,
    },
    estrangeiro: String,

  },
  data() {
    return {
      error: false,
      cpfError: "",
       pis: '',
      pisError: '',
    };
  },

  computed: {

    isFormValid() {

    return this.validateCPF() && this.validatePisPasep();
  }

   
  //   isFormValid() {
  //       const pis = (this.dadosDocumentacao.pisPasep || "").replace(/\D/g, "");
  // const pisValido = pis === "" || this.validatePisPasep();
  //     return (
  //   !this.error &&
  //   pisValido &&
  //   !this.cpfError &&
  //   this.dadosDocumentacao.cpf.replace(/\D/g, "").length === 11
  //     );
  //   }

   },

  methods: {
  
   validatePisPasep() {
  const clean = (this.dadosDocumentacao.pisPasep || '').replace(/\D/g, '');

  // Campo vazio é permitido
  if (!clean) {
    this.pisError = '';
    return true;
  }

  // Se preenchido, deve ter exatamente 11 dígitos
  if (clean.length !== 11) {
    this.pisError = 'PIS/PASEP deve conter exatamente 11 dígitos.';
    return false;
  }

  this.pisError = '';
  return true;
},





    validateCPF(focusIfInvalid = false) {
      const cleanCPF = (this.dadosDocumentacao.cpf || "").replace(/\D/g, "");

      if (!cleanCPF) {
        this.cpfError = "";
        return true;
      }

      if (!/^\d{11}$/.test(cleanCPF)) {
        this.cpfError = "CPF deve conter 11 dígitos.";
        if (focusIfInvalid) {
          this.$nextTick(() => {
            this.$refs.cpfInput?.focus();
            this.$refs.cpfInput?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          });
        }
        return false;
      }

      if (/^(\d)\1{10}$/.test(cleanCPF)) {
        this.cpfError = "CPF inválido.";
        if (focusIfInvalid) {
          this.$nextTick(() => {
            this.$refs.cpfInput?.focus();
            this.$refs.cpfInput?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          });
        }
        return false;
      }

      const calcDV = (cpf, factor) => {
        let total = 0;
        for (let i = 0; i < factor - 1; i++) {
          total += parseInt(cpf[i]) * (factor - i);
        }
        const remainder = (total * 10) % 11;
        return remainder === 10 ? 0 : remainder;
      };

      const dv1 = calcDV(cleanCPF, 10);
      const dv2 = calcDV(cleanCPF, 11);

      if (dv1 !== parseInt(cleanCPF[9]) || dv2 !== parseInt(cleanCPF[10])) {
        this.cpfError = "CPF inválido.";
        if (focusIfInvalid) {
          this.$nextTick(() => {
            this.$refs.cpfInput?.focus();
            this.$refs.cpfInput?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          });
        }
        return false;
      }

      this.cpfError = "";
      return true;
    }

  },
};
</script>

<style scoped>
.error-message {
  color: red;
  font-size: 0.875rem;
  margin-top: 0.25rem;
}
</style>
